(() => {
  if (window.hhCatalogueMenuReady) return;
  window.hhCatalogueMenuReady = true;
  const menus = new Map();
  const resize = () => {
    for (const [menu] of menus) {
      if (!menu.isConnected || menu.hidden) continue;
      const bottom = window.visualViewport?.height || window.innerHeight;
      menu.style.setProperty('--catalogue-available-height', `${Math.max(160, bottom - menu.getBoundingClientRect().top - 16)}px`);
    }
  };
  const close = (menu, returnFocus = false) => {
    const trigger = menu.parentElement.querySelector(':scope > a');
    if (returnFocus) trigger?.focus({ preventScroll: true });
    menu.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.classList.remove('is-mega-active');
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-catalogue-menu]').forEach(menu => {
      if (menus.has(menu)) return;
      const observer = new MutationObserver(resize);
      observer.observe(menu, { attributes: true, attributeFilter: ['hidden'] });
      menus.set(menu, observer);
      menu.querySelector('[data-catalogue-close]')?.addEventListener('click', () => close(menu, true));
      menu.parentElement.addEventListener('keydown', event => {
        const trigger = menu.parentElement.querySelector(':scope > a');
        if (event.target === trigger && (event.key === 'ArrowDown' || event.key === ' ')) {
          event.preventDefault();
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          trigger.classList.add('is-mega-active');
          resize();
          menu.querySelector('a[href]')?.focus();
          return;
        }
        if (event.key !== 'Escape' || menu.hidden) return;
        event.preventDefault();
        close(menu, true);
      });
    });
    resize();
  };
  let frame = 0;
  const scheduleResize = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; resize(); });
  };
  window.addEventListener('resize', scheduleResize, { passive: true });
  window.addEventListener('scroll', scheduleResize, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleResize, { passive: true });
  document.addEventListener('click', event => {
    for (const [menu] of menus) if (!menu.hidden && !menu.parentElement.contains(event.target)) close(menu);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [menu, observer] of menus) {
      if (!event.target.contains(menu)) continue;
      observer.disconnect();
      menus.delete(menu);
    }
  });
  init();
})();
